// extracted by mini-css-extract-plugin
export default {"H1":"h1_H1__FJg8g","NoMT":"h1_NoMT__JoGNA","IconLeft":"h1_IconLeft__m24oF","IconRight":"h1_IconRight__2JREm"};